<template>
  <a-modal
    :title="modalTitle"
    width="80%"
    :visible="open"
    :footer="null"
    v-highlight
    @cancel="onClose"
    :bodyStyle="{ height: '580px'}"
  >
    <!-- 数据展示 -->
    <a-table
      :loading="loading"
      :size="tableSize"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      :pagination="false"
      :bordered="tableBordered"
      :scroll="{ y: 380 }"
    >
      <span slot="createTime" slot-scope="text, record">
        {{ parseTime(record.createTime) }}
      </span>
      <div slot="avatar" slot-scope="text, record">
        <img :src="record.avatar" style="width:100px; cursor: pointer;" preview alt=""/>
      </div>
      <span slot="operation" slot-scope="text, record">
        <a @click="handleAudit(record, 2)">
          <a-icon type="check" />通过
        </a>
        <a-divider type="vertical" v-hasPermi="['played:rebate/task:remove']" />
        <a @click="handleAudit(record, 3)">
          <a-icon type="close" />驳回
        </a>
      </span>
    </a-table>
    <!-- 分页 -->
    <a-pagination
      class="ant-table-pagination"
      show-size-changer
      :show-quick-jumper="false"
      :current="queryParam.pageNum"
      :total="total"
      :page-size="queryParam.pageSize"
      :showTotal="total => `共 ${total} 条`"
      @showSizeChange="onShowSizeChange"
      @change="changeSize"
    />
  </a-modal>
</template>

<script>
import { pageUserShopAudit, adminAuditJoinApply } from '@/api/played/userShopAudit'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'ShopUserAudit',
  props: {
  },
  components: {
  },
  mixins: [tableMixin],
  data () {
    return {
      modalTitle: undefined,
      loading: false,
      list: [],
      total: 0,
      // 查询参数
      queryParam: {
        shopId: undefined,
        auditStatus: 1,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '用户昵称',
          dataIndex: 'nickName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '用户头像',
          dataIndex: 'avatar',
          scopedSlots: { customRender: 'avatar' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '申请时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '10%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      selectedRowKeys: [],
      selectedRows: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      open: false
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    getList() {
      this.loading = true
      pageUserShopAudit(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    onClose () {
      this.open = false
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    handle (row) {
      this.modalTitle = `《${row.shopName}》加入申请`
      this.open = true
      this.queryParam = {
        shopId: row.shopId,
        auditStatus: 1,
        pageNum: 1,
        pageSize: 10
      }
      this.getList()
    },
    handleAudit (row, auditStatus) {
      console.log(row)
      var that = this
      var auditTitle = auditStatus === 3 ? '驳回' : '通过'
      this.$confirm({
        title: `确认${auditTitle}?`,
        content: `${row.nickName}的入店申请`,
        onOk () {
          return adminAuditJoinApply({ id: row.id, auditStatus: auditStatus })
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '审批成功',
                3
              )
            })
        },
        onCancel () {}
      })
    }
  }
}
</script>
